import { Component, OnInit, ViewChild } from '@angular/core';
import { DistributionHeaderComponent } from '../abstract-header/distribution-header.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { EmailDistributionJob } from '../../../models/distribution-doc-models';
import { EmailChipsComponent } from '../../email-chips/email-chips.component';

@Component({
    selector: 'email-distribution-header',
    templateUrl: './email-distribution-header.component.html',
    styleUrls: ['./email-distribution-header.component.scss']
})
export class EmailDistributionHeaderComponent extends DistributionHeaderComponent<EmailDistributionJob>
                                              implements OnInit {

    @ViewChild('to_chips')
    private to_chips: EmailChipsComponent;

    public to_addressesInvalid = false;
    public cc_addressesInvalid = false;
    public bcc_addressesInvalid = false;

    public ccAndBccVisible: boolean;

    get job(): EmailDistributionJob {
        return this.bananaBox;
    }

    constructor(public dialog: MatDialog) {
        super();
        this._idPrefix = 'email.';
    }

    public ngOnInit() {
        super.ngOnInit();
        this.ccAndBccVisible = !!this.job.email_cc || !!this.job.email_bcc;
    }

    public showCCAndBCC(): void {
        this.ccAndBccVisible = true;
    }

    public isValid() {
        return !!this.job.email_subject && !!this.job.email_to;
    }

    public validate(): boolean {
        this.to_chips.validate();
        return !this.to_addressesInvalid && !this.cc_addressesInvalid && !this.bcc_addressesInvalid;
    }
}
